// extracted by mini-css-extract-plugin
module.exports = {"card":"about_card__JPWe_","graphList":"about_graphList__NP_8Q","center":"about_center__akmFu","date":"about_date__NDQCX","svgContainer":"about_svgContainer___eZr3"};